<template>
  <div class="detail-subject">
    <BreadcrumClass />
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-12 detail-left">
          <div class="item-class display-flex">
            <div class="info-left display-flex">
              <img src="@/assets/img/icon-list.png" alt />
              <div class="info-class text-left">
                <h2 class="primary-color font-sanpro-semibold font-size-16">{{getCourseDetail.name}}</h2>
                <h3
                  class="secondary-color-txt font-family-Semibold font-size-14"
                >{{getCourseDetail.school}}</h3>
                <h3 class="secondary-color-txt font-family-Semibold font-size-14">
                  Mã lớp:
                  <router-link
                    class="primary-color font-sanpro-semibold font-size-14"
                    :to="{name:'ViewCodeClass',params:{classId:getCourseDetail.classSchoolSubjectId}}"
                  >{{getCourseDetail.code}}</router-link>
                </h3>
              </div>
            </div>
          </div>
          <div class="status-join display-flex">
            <div class="form-group select-status">
              <select class="form-control" id="status">
                <option>Đã tham gia</option>
                <option>Chưa tham gia</option>
                <option>Đã hoàn thành</option>
              </select>
              <i class="fa fa-angle-down"></i>
            </div>
            <div class="dropdown dropdown-account">
              <button
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                class="dropdown-toggle"
              >
                <i class="fas fa-ellipsis-h"></i>
              </button>
              <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                <a href="javascript:;" class="dropdown-item" role="button">Xem thông tin</a>
                <a href="javascript:;" class="dropdown-item" role="button">Rời lớp</a>
                <a href="javascript:;" class="dropdown-item" role="button">Báo cáo</a>
              </div>
            </div>
          </div>
          <!-- <InfoClassLeft /> -->
          <div class="menu-tabs">
              <router-link :to="{name: 'ViewDetailSubject',params:{id :classSchoolSubjectId}}"    >Nội dung môn học</router-link>
              <router-link  :to="{name: 'viewDetailDiscuss',params:{id :classSchoolSubjectId}}" >Thảo luận</router-link>
              <router-link :to="{name: 'ViewdetailCalendar',params:{id :classSchoolSubjectId}}">Lịch</router-link>
              <router-link :to="{name: 'ViewDetailDoccument'}" >Tài liệu</router-link>
          </div>
        </div>
        <div class="col-lg-8 col-md-8 col-12 detail-right">
          <div class="container">
            <div class="row info-right">
              <div class="col-3">
                <h3 class="secondary-color-txt font-sanpro-semibold font-size-16">Ngày mở lớp</h3>
                <span
                  class="font-size-16 font-family-Semibold primary-color-txt"
                >{{moment(getCourseDetail.fromDate).format(formatDate1)}}</span>
              </div>
              <div class="col-3">
                <h3 class="secondary-color-txt font-sanpro-semibold font-size-16">Tổng số thành viên</h3>
                <span
                  class="font-size-16 font-family-Semibold primary-color-txt"
                >{{getCourseDetail.numberOfMember}}</span>
              </div>
              <div class="col-3">
                <h3 class="secondary-color-txt font-sanpro-semibold font-size-16">Số giáo viên</h3>
                <span
                  class="font-size-16 font-family-Semibold primary-color-txt"
                >{{getCourseDetail.numberOfTeacher}}</span>
              </div>
              <div class="col-3">
                <h3 class="secondary-color-txt font-sanpro-semibold font-size-16">Số học sinh</h3>
                <span
                  class="font-size-16 font-family-Semibold primary-color-txt"
                >{{getCourseDetail.numberOfStudent}}</span>
              </div>
            </div>
            <div class="row search display-flex justify-content-between">
              <div class="form">
                <form class="form-training">
                  <input
                    v-model.lazy="keyword"
                    v-debounce="300"
                    type="text"
                    placeholder="Tìm kiếm"
                    required="required"
                  />
                  <button type="submit">
                    <i class="fa fa-search secondary-color-blue"></i>
                  </button>
                </form>
              </div>
              <div class="form-group select-status">
                <select class="form-control" id="status" v-model="selectedPositionId" @change="handelePositionId">
                  <option value="0">Tất cả thành viên</option>
                  <option  :value="item.classPositionId" v-for="(item,index) of getListClassPostion" :key="index">{{item.name}}</option>
                </select>
                <i class="fa fa-angle-down"></i>
              </div>
            </div>
          </div>
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="title-table font-size-14 secondary-color-txt">Tên</th>
                <th
                  scope="col"
                  class="title-table font-size-14 secondary-color-txt text-center"
                >Vai trò</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="getClassListMember && getClassListMember.list" v-for="(item, index) in getClassListMember.list" :key="index">
                <td data-label="Tên: " class="name-row-table">
                  <img src="@/assets/images/user.png" alt />
                  <span class="primary-color font-size-16 font-sanpro-semibold">{{item.name}}</span>
                </td>
                <td
                  data-label="Vai trò :"
                  class="name-row-table font-family-Semibold font-size-14 text-center"
                >{{item.position}}</td>
              </tr>
            </tbody>
          </table>
          <!-- <p class="col-12 text-center pagiination-training">
            <Pagination
              @eventPagination="getClassPagination"
              :totalPage="pagingData.totalPage"
              :page="pagingData.pageIndex"
            />
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import BreadcrumClass from "../_components/breadcrumb/BreadcrumbClass";
import debounce from "@/directives/debounce";
import Pagination from "@/components/Pagination.vue";
import moment from "moment";
export default {
  name: "ViewCodeClass",
  directives: { debounce },
  data() {
    return {
      selectedPositionId:0,
      keyword: "",
      classSchoolSubjectId: this.$route.params.classId,
      formatDate1: "DD/MM/YYYY",
    };
  },
  components: {
    BreadcrumClass,
    Pagination,
    pagingData:{}
  },
  computed: {
    ...mapGetters({
      getClassListMember: STORE_KEY + "/getClassListMember",
      getCourseDetail: STORE_KEY + "/getCourseDetail",
      getParamListSchool: STORE_KEY + "/getParamListSchool",
      getListClassPostion: STORE_KEY + "/getListClassPostion",
    })
  },
  watch: {
    keyword: "classSerach",
    getParamListSchool: "fetchSchoolList",
    getClassListMember(newVal,oldVal){
      // this.pagingData  = newVal.paging;
    },
  },
  mounted() {
  this.actionGetListClassPosition();
    this.actionGetCourseDetail(this.classSchoolSubjectId);
    this.actionSetParamListSchool({
      ...this.getParamListSchool,
      pageIndex: 1,
      pageSize: 10,
      classSchoolSubjectId: this.classSchoolSubjectId
    });
    // this.actionGetListMember();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
      "actionGetListMember",
      "actionGetCourseDetail",
      "actionSetParamListSchool",
      "actionClassSchoolListMember",
      "actionGetListClassPosition"
    ]),
    moment,
    ...mapActions(`common`, ["setLoading"]),
    classSerach() {
      this.actionSetParamListSchool({
        ...this.getParamListSchool,
        keyword: this.keyword
      });
    },
    handelePositionId(){
      this.actionSetParamListSchool({
        ...this.getParamListSchool,
        ClassPositionId: this.selectedPositionId
      })
    },
    fetchSchoolList() {
      this.setLoading(true);
      this.actionClassSchoolListMember(this.getParamListSchool).finally(() => {
        this.setLoading(false);
      });
    },
    getClassPagination(value) {
      this.setLoading(true);
      this.actionSetParamListSchool({
        ...this.getParamListSchool,
        pageIndex: value
      }).finally(() => {
        this.setLoading(false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.info-right {
  background: #f3f6fb;
  padding: 15px 5px;
  border-radius: 5px;
  margin-bottom: 37px;
}
.table {
  tr:first-child {
    border-top: 2px solid #fff;
  }
  img {
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.search {
  margin-top: 20px;
  .form {
    height: 30px;
    width: 377px;
    .form-training {
      position: relative;
      button {
        position: absolute;
        top: 4px;
        z-index: 1;
        background-color: transparent;
        border: 0;
        color: #124abe;
        outline: 0;
        right: 13px;
        font-size: 14px;
      }
      input {
        border-radius: 20px;
        height: 30px;
        padding: 0 35px 0 12px;
        top: 0;
        left: 0;
        border: 0;
        color: #40505e;
        outline: 0;
        background-color: #f3f6fb;
        font-size: 15px;
        width: 100%;
        position: static;
      }
    }
  }
  .select-status {
    position: relative;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding: 2px 30px 2px 10px;
      border: none;
      background: none;
      border-radius: 20px;
      height: 30px;
      font-size: 14px;
      color: #879aa9;
    }
    i {
      position: absolute;
      top: 7px;
      right: 8px;
      color: #879aa9;
    }
  }
}
.dropdown-account {
  margin-left: 10px;
}
.dropdown button {
  width: 30px;
  background: #f3f6fb;
  color: #879aa9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background: #f3f6fb;
}
.dropdown button:focus {
  background: #f3f6fb !important;
  color: #124abe;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}
@media (max-width: 768px) {
  .search .form {
    width: 325px;
  }
}
@media (max-width: 425px) {
  .dropdown-menu {
    padding: 0rem 0 0.5rem;
    margin: 0.125rem 0 0;
    box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
    transform: translate3d(167px, 30px, 0px) !important;
  }
}
</style>